<template>
  <div class="wrap">
    <div class="logo">
      <img src="~@/assets/images/logo.svg" alt="" />
    </div>
    <main class="main">
      <div class="boss-logo">
        <img v-if="logo" :src="logo" />
      </div>
      <div class="title">{{ title || "森果老板助手" }}</div>
      <div class="wechat-login" v-if="WxLoginShow && isShowLogin">
        <div class="button" @click="handleWeChatLogin">
          <base-icon icon="iconweixin" fontSize="38" />
          <span style="margin-left: 10px">微信登录</span>
        </div>
        <span v-if="loginType === 'wechat'" class="login--type">上次登录</span>
      </div>
      <div class="phone-login">
        <div class="button" @click="handlePhoneLogin">
          <span>手机号登录</span>
        </div>
        <span v-if="loginType === 'phone'" class="login--type">上次登录</span>
      </div>
      <div class="read--wrap">
        <el-checkbox
          :value="read"
          @change="handleReadChange"
          class="read--checkbox"
        ></el-checkbox>
        <span>我已阅读并同意</span>
        <span style="color: #63a6ff" @click="seeUserAgreement"
          >《用户协议》</span
        >
        <span>和</span>
        <span style="color: #63a6ff" @click="seePrivacyAgreement"
          >《隐私协议》</span
        >
      </div>
    </main>

    <footer class="footer">
      <div class="footer--line">其他登录方式</div>
      <div class="footer--control">
        <button
          class="footer--btn"
          v-if="isNewLs && isShowLogin"
          @click="handleDyLogin"
        >
          <div class="footer--btn-icon">
            <base-icon icon="icondouyin" fontSize="24" />
          </div>
          <span class="footer--btn-text">抖音登录</span>

          <span v-if="loginType === 'douyin'" class="login--type"
            >上次登录</span
          >
        </button>
      </div>
    </footer>

    <privacy-agreement-dialog
      ref="privacyDialog"
      :hasLogin="hasLogin"
      @confirm="handleReadChange"
    />
  </div>
</template>

<script>
import subDomain from "@/config/systemDomain";
import { isAndroid } from "@/assets/js/util";
import {
  whatApp,
  loginStorageDao,
  initPluginsWithPrivacy,
  getJPushID,
  checkIsNewPrivacy,
} from "@/utils";
import JsBridge from "@/assets/js/js-bridge";
import { privacyUrl, userUrl } from "@/config/config";
import PrivacyAgreementDialog from "../components/privacy-agreement-dialog";
import { shouldForceBindPhone, shouldForceBindWx } from "@/utils/auth-strategy";

const appLogo = {
  new_ls: require("@/assets/images/new_ls_logo.png"),
  wsc: require("@/assets/images/wsc_logo.png"),
  other: require("@/assets/images/bossLogo.svg"),
};
let cacheRead = undefined;

export default {
  components: {
    PrivacyAgreementDialog,
  },
  data() {
    return {
      read: Boolean(cacheRead),
      loginType: loginStorageDao.getData().type,
      isShowLogin: true,
    };
  },
  computed: {
    isNewLs() {
      return whatApp('new_ls')
    },
  },

  created() {
    this.WxLoginShow = !whatApp("wsc") || isAndroid();
    // this.checkIosStore('1.2.0')
    this.isAndroid = isAndroid;
    if (whatApp("new_ls")) {
      this.title = "零售通";
      this.logo = appLogo.new_ls;
    } else if (whatApp("wsc")) {
      this.title = "微商城";
      this.logo = appLogo.wsc;
    } else {
      this.logo = appLogo.other;
    }

    this.init();
    this.agreeProtocolCallback = () => {};
  },
  mounted() {
    this.$nextTick(() => {
      if (typeof cacheRead === "undefined") {
        const loginData = loginStorageDao.getData();
        const isNeedShowPrivacy =
          typeof cacheRead === "boolean"
            ? !cacheRead
            : checkIsNewPrivacy()
            ? false
            : loginData.hasLogin
            ? false
            : true;
        if (isNeedShowPrivacy && this.$refs.privacyDialog) {
          this.$refs.privacyDialog.show();
        }
      }
    });
  },

  methods: {
    init() {
      this.$fetch
        .get({
          url: "/user",
        })
        .then((data) => {
          if (data.success && data.user) {
            const user = data.user;
            const needBindPhone = shouldForceBindPhone(user);
            const needBindWx = shouldForceBindWx(user);
            if (!needBindPhone && !needBindWx) {
              window.location.href = subDomain.center_domain_m + "/#/loading";
            } else {
              this.$router.push({ path: "/mobileRegister" });
            }
          }
        });
    },

    wechatLoginEvent() {
      if (!this.read) return this.openMessage(0, "请先同意用户协议再登录");
      if (isAndroid()) {
        try {
          window.Assistant.getWxLoginCode("WxLoginCallback");
        } catch (e) {
          this.openMessage(0, "暂无客户端授权");
        }
      } else {
        try {
          window.webkit.messageHandlers.NativeApi.postMessage({
            func: "getWxLoginCode",
            param: "WxLoginCallback",
          });
        } catch {
          this.openMessage(0, "暂无客户端授权");
        }
      }
    },

    // ios 商店审核 屏蔽微信登陆
    checkIosStore(version) {
      JsBridge.invokeMethod("getCurrentVersion", (data) => {
        if (!data) return;
        if (data.versionName === version) {
          this.isShowLogin = false;
        }
      });
    },

    // 抖音登陆
    dyLoginEvent() {
      if (!this.read) return this.openMessage(0, "请先同意用户协议再登录");

      JsBridge.invokeMethod("getDouyinLoginCode", (code) => {
        const source = whatApp();
        // 清除code
        this.$fetch
          .post({
            url: "/login?method=login_by_dy_code",
            params: {
              code,
              source: source ? source : undefined,
            },
          })
          .then((res) => {
            loginStorageDao.setData({
              hasLogin: true,
              type: "douyin",
            });
            // 判断是否绑定手机
            if (!res.phone_bind) {
              this.$router.push({ path: "/mobileRegister" });
            } else if (!res.bind_wx) {
              // 未绑定微信， 去绑定微信
              if (isAndroid()) {
                try {
                  window.Assistant.getWxLoginCode("bindWxCallback");
                } catch (e) {
                  this.openMessage(0, "暂无客户端授权");
                }
              } else {
                if (whatApp("wsc"))
                  return this.openMessage(0, "请前往PC端注册绑定微信和手机号");
                try {
                  window.webkit.messageHandlers.NativeApi.postMessage({
                    func: "getWxLoginCode",
                    param: "bindWxCallback",
                  });
                } catch {
                  this.openMessage(0, "暂无客户端授权");
                }
              }
            } else {
              this.bindJpushId();
            }
          })
          .catch(() => {
            // 异常回到mobileInit页面
            this.$router.push({ path: "/mobileInit" });
          });
      });
    },

    // 手机号登录
    phoneLoginEvent() {
      if (!this.read) return this.openMessage(0, "请先同意用户协议再登录");

      this.$router.push({ path: "/mobileLogin" });
    },

    bindJpushId() {
      getJPushID().then((val) => {
        this.$fetch
          .post({
            url: "/updatedevicealias",
            params: {
              registration_id: val,
            },
          })
          .then(() => {
            window.location.href = subDomain.center_domain_m + "/#/loading";
          })
          .catch(() => {
            window.location.href = subDomain.center_domain_m + "/#/loading";
          });
      });
    },

    seeUserAgreement() {
      window.location.href = userUrl;
    },

    seePrivacyAgreement() {
      window.location.href = privacyUrl;
    },

    handleReadChange(val) {
      this.read = val;
      cacheRead = val;

      if (val) {
        initPluginsWithPrivacy();
      }
      this.agreeProtocolCallback();
    },
    handleWeChatLogin() {
      if (this.read) {
        this.wechatLoginEvent();
      } else {
        this.$refs.privacyDialog.show();
        this.agreeProtocolCallback = () => {
          this.wechatLoginEvent();
          this.agreeProtocolCallback = () => {};
        };
      }
    },
    handlePhoneLogin() {
      if (this.read) {
        this.phoneLoginEvent();
      } else {
        this.$refs.privacyDialog.show();
        this.agreeProtocolCallback = () => {
          this.phoneLoginEvent();
          this.agreeProtocolCallback = () => {};
        };
      }
    },
    handleDyLogin() {
      if (this.read) {
        this.dyLoginEvent();
      } else {
        this.$refs.privacyDialog.show();
        this.agreeProtocolCallback = () => {
          this.dyLoginEvent();
          this.agreeProtocolCallback = () => {};
        };
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.wrap {
  position: relative;
  width: 100%;
  height: 100vh;
  background: url("~@/assets/images/bossBg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;

  .logo {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 60px;
    height: 24px;
    img {
      width: 100%;
    }
  }

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin-top: -10px;
    text-align: center;

    .boss-logo {
      width: 84px;
      height: 84px;
      border-radius: 8px;
      overflow: hidden;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      margin-top: 12px;
      font-size: 30px;
      font-weight: bold;
      color: #333;
      text-align: center;
    }

    .wechat-login {
      position: relative;
      margin-top: 30px;
      width: 100%;
      height: 50px;
      padding: 0 30px;

      .button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        font-size: 20px;
        color: #fff;
        border-radius: 25px;
        box-shadow: 0 2px 8px 0 rgba(0, 150, 136, 0.6);
        background-color: #009688;

        &:active {
          background-color: rgba(0, 134, 122, 1);
        }
      }

      .login--type {
        left: 50%;
        top: 4px;
        margin-left: 55px;
      }
    }
    .phone-login {
      position: relative;
      margin-top: 20px;
      width: 100%;
      height: 50px;
      padding: 0 30px;

      .button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        font-size: 16px;
        color: #999;
        border-radius: 25px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

        &:active {
          background-color: rgba(0, 0, 0, 0.1);
        }

        .iconfanhui1 {
          margin-left: 10px;
          font-size: 20px;
        }
      }

      .login--type {
        left: 50%;
        top: 4px;
        margin-left: 30px;
      }
    }

    .read--wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      margin-top: 20px;
      color: #666;
      .read--checkbox {
        margin-right: 6px;
        position: relative;
        &::after {
          position: absolute;
          left: -10px;
          right: -10px;
          top: -10px;
          bottom: -10px;
          content: "";
        }
      }
    }
  }

  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 34px;

    .footer--line {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #999;

      &::before,
      &::after {
        display: inline-block;
        content: "";
        width: 60px;
        height: 1px;
        background: linear-gradient(
          90deg,
          #ebebeb 51.67%,
          hsla(0, 0%, 92.2%, 0) 105%
        );
        border-radius: 1px;
      }
      &::before {
        transform: rotate(180deg);
        margin-right: 6px;
      }
    }
    .footer--control {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 20px;
    }
    .footer--btn {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 80px;
      appearance: none;
      background: none;
      outline: none;
      border: none;
      padding: 0;

      .login--type {
        left: 0;
        top: -4px;
        margin-left: 50px;
      }
    }
    .footer--btn-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      border-radius: 22px;
      border: 1px solid #ebebeb;
    }
    .footer--btn-text {
      font-size: 14px;
      line-height: 16px;
      margin-top: 4px;
      color: #666;
    }
  }

  .login--type {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 16px;
    font-size: 10px;
    font-weight: bold;
    color: #ff5a12;
    background: #ffefe8;
    border: 0.5px solid #ffffff;
    border-radius: 8px 8px 8px 0;

    position: absolute;
  }
}
</style>